import { Injectable, signal } from '@angular/core';
import { Dimension2d } from './model';

@Injectable({
  providedIn: 'root',
})
export class OverlayDimensionService {
  private readonly _dimensionsByPageId = signal<Record<string, Dimension2d>>({});

  dimensionsByPageId = this._dimensionsByPageId.asReadonly();

  setDimension(pageId: string, dimension: Dimension2d) {
    this._dimensionsByPageId.update((dimensions) => ({ ...dimensions, [pageId]: dimension }));
  }
}
